import { LocalHistoryService } from 'src/app/core/services/local-history.service';
import { Component, OnInit, inject, input } from '@angular/core';
import { Location } from '@angular/common';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { TextGradientComponent } from '../text-gradient/text-gradient.component';
import { BtnComponent } from '../btn/btn.component';

@Component({
    selector: 'app-top-back',
    templateUrl: './top-back.component.html',
    styleUrls: ['./top-back.component.scss'],
    imports: [BtnComponent, TextGradientComponent, TranslatePipe]
})
export class TopBackComponent {
  private _history = inject(LocalHistoryService);
  private _location = inject(Location);


  readonly title = input<string>(undefined);

  public backToPreviousPage() {
    const previousUrl = this._history.getPreviousUrl();
    if (previousUrl) {
      this._location.back();
    }
  }

}
